// extracted by mini-css-extract-plugin
module.exports = {"buildButton":"AiCopilotBanner_buildButton__SvPvk"};